import { ChangeDetectorRef, Component, inject } from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {ContextualHelpPanelService} from '@core/services/contextual-help-panel.service';
import { AsyncPipe, CommonModule } from '@angular/common';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-contextual-help-panel-trigger',
    templateUrl: './contextual-help-panel-trigger.component.html',
    styleUrls: ['./contextual-help-panel-trigger.component.scss'],
    imports: [
        MatIcon,
        AsyncPipe,
        CommonModule,
    ],
})
export class ContextualHelpPanelTriggerComponent {
  protected helpPanelService = inject(ContextualHelpPanelService);
  protected changeDetectorRef = inject(ChangeDetectorRef);


  constructor() {
    this.helpPanelService.dataExistsForPage$
      .pipe(untilDestroyed(this))
      .subscribe((dataExistsForPage) => {
        if (dataExistsForPage) {
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  toggleOpenHelpPanel() {
    this.helpPanelService.toggleHelpPanelOpen();
  }
}
